import { DataSyncSuccessDialog, fetchAuthConfigForDataSync } from './DataSync';
import { UnifiedAuthView } from './LowLevelUnifiedAuth';
import { DataSyncIntroScreen } from './DataSync';
import { getDataSyncScreens } from './DataSyncRegistry';
import { UniversalAuthTracker } from './UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataSyncAuthModal({
  portalId,
  appId,
  accountId,
  onComplete,
  onCancel,
  onOpenExternalLink,
  onSetupSyncClick,
  onDoThisLaterClick,
  trackingSource,
  introScreen,
  successScreen
}) {
  var _ref, _ref2;
  const renderDefaultSuccessScreen = ({
    appName,
    authResponse
  }) => /*#__PURE__*/_jsx(DataSyncSuccessDialog, {
    appName: appName,
    onCancel: onCancel,
    portalId: portalId,
    appId: appId,
    authResponse: authResponse,
    onOpenExternalLink: onOpenExternalLink,
    onSetupSyncClick: onSetupSyncClick,
    onDoThisLaterClick: onDoThisLaterClick
  });
  const registryScreens = getDataSyncScreens(appId);
  const resolvedIntroScreen = (_ref = introScreen !== null && introScreen !== void 0 ? introScreen : registryScreens === null || registryScreens === void 0 ? void 0 : registryScreens.introScreen) !== null && _ref !== void 0 ? _ref : DataSyncIntroScreen;
  const resolvedSuccessScreen = (_ref2 = successScreen !== null && successScreen !== void 0 ? successScreen : registryScreens === null || registryScreens === void 0 ? void 0 : registryScreens.successScreen) !== null && _ref2 !== void 0 ? _ref2 : renderDefaultSuccessScreen;
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: true,
    isReauth: !!accountId,
    portalId: portalId,
    onComplete: account => {
      UniversalAuthTracker.track('app-management', {
        applicationId: appId,
        source: trackingSource || 'unknown',
        action: accountId ? 'APP_RECONNECTED' : 'APP_CONNECTED'
      });
      onComplete(account);
    },
    onCancel: onCancel,
    introScreen: resolvedIntroScreen,
    fetchAuthConfig: fetchAuthConfigForDataSync(portalId, appId, accountId, undefined /* don't override the hublet */),
    successScreen: resolvedSuccessScreen
  });
}
export default DataSyncAuthModal;